import { Parameter } from '@shared/types';
import WorkspaceFile from '../lib/WorkspaceFile.ts';

// Credit
// https://github.com/seasick/openscad-web-gui/blob/main/src/worker/types.ts

export const enum WorkerMessageType {
  PREVIEW = 'preview',
  PREVIEW_SVG = 'preview.svg',
  EXPORT = 'export',
  MULTI_EXPORT = 'multiExport',
  FS_READ = 'fs.read',
  FS_WRITE = 'fs.write',
  FS_UNLINK = 'fs.unlink',
}

type WorkerMessageDataMap = {
  [WorkerMessageType.PREVIEW]: OpenSCADWorkerMessageData;
  [WorkerMessageType.PREVIEW_SVG]: OpenSCADWorkerMessageData;
  [WorkerMessageType.EXPORT]: OpenSCADWorkerMessageData;
  [WorkerMessageType.MULTI_EXPORT]: OpenSCADMultiExportRequest;
  [WorkerMessageType.FS_READ]: FileSystemWorkerMessageData;
  [WorkerMessageType.FS_WRITE]: FileSystemWorkerMessageData;
  [WorkerMessageType.FS_UNLINK]: FileSystemWorkerMessageData;
};

export type WorkerMessage = {
  id?: string | number;
  type: WorkerMessageType;
  data: WorkerMessageDataMap[WorkerMessage['type']];
};

export type WorkerResponseMessage = {
  id: string | number;
  type: WorkerMessageType;
  data:
    | OpenSCADWorkerResponseData
    | OpenSCADMultiExportResponse
    | FileSystemWorkerMessageData
    | boolean
    | null;
  err?: Error;
};

export type OpenSCADWorkerMessageData = {
  code: string;
  fileType: string;
  params: Parameter[];
};

export type OpenSCADWorkerResponseData = {
  log: {
    stdErr: string[];
    stdOut: string[];
  };
  fileType: string;
  output: Uint8Array;
  exitCode: number;
  duration: number;
};

export type FileSystemWorkerMessageData = {
  path: string;
  content?: WorkspaceFile | ArrayBuffer; // Content is only necessary when writing
  type?: string; // MIME type, needed if content is ArrayBuffer
};

export type OpenSCADExportFormat = 'stl' | '3mf' | 'svg';

export interface OpenSCADMultiExportRequest {
  code: string;
  params: Parameter[];
  /** Which formats to produce. The worker compiles once per format and emits each. */
  formats: OpenSCADExportFormat[];
}

export interface OpenSCADMultiExportResponse {
  /** Each entry: format → binary output bytes. Format keys present only when produced. */
  outputs: Partial<Record<OpenSCADExportFormat, Uint8Array>>;
  /** Compile log; worker captures stderr too. */
  log: { stdOut: string[]; stdErr: string[] };
}
